import ReactDOM from "react-dom/client";
import "./index.scss";

import BugsnagPerformance from "@bugsnag/browser-performance";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

import App from "./App";

import "@southfields-digital/mxmz-react-ui/style.css";
import { StrictMode } from "react";

if (import.meta.env.VITE_BUGSNAG_API_KEY) {
	Bugsnag.start({
		apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
		releaseStage: import.meta.env.VITE_BUGSNAG_STAGE || "development",
		plugins: [new BugsnagPluginReact()],
	});
	BugsnagPerformance.start({ apiKey: import.meta.env.VITE_BUGSNAG_API_KEY });
}

const root = document.getElementById("root");
if (root) {
	ReactDOM.createRoot(root).render(
		<StrictMode>
			<App />
		</StrictMode>,
	);
}
